export function slugify(text: string) {
    return encodeURIComponent(text
        .toString()
        .normalize("NFKD")
        .replace(/[\u0591-\u05C7]/g, "")
        .toLowerCase()
        .trim()
        .replace(/[^\u0590-\u05FFa-z0-9\s_-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, ""));
}